export default __webpack_public_path__ + "static/media/BhaskarBG.8bbd3316.webp";